import { AbstractControl } from '@angular/forms';
import { formatDate } from '@angular/common';

const LOCALE_ID = 'en-US';
const DATE_FORMAT = 'yyyy-MM-dd';

export const dateRangeValidator = (control: AbstractControl): {[key: string]: boolean} => {
  try {
    const selectStartDate = formatDate(control.get('selectStartDate').value, DATE_FORMAT, LOCALE_ID);
    const selectEndDate = formatDate(control.get('selectEndDate').value, DATE_FORMAT, LOCALE_ID);
    return (selectEndDate < selectStartDate) ? {invalidDateRange: true} : null;
  } catch (error) {
    return {invalidDates: true};
  }
};
